import { type FetchResponse } from '@libraries/typescript/api_client/types';

type ApiErrorOptions = {
    readonly originalError?: unknown;
    readonly isNetworkError?: boolean;
    readonly isAbortError?: boolean;
    readonly globalOverloadRetryAtMs?: number;
    readonly rateLimitedScope?: string;
    readonly rateLimitedRetryAtMs?: number;
    readonly rateLimitSuppressed?: boolean;
    readonly requestId?: string;
    readonly transparentRateLimitSource?: 'principal' | 'global-overload';
};

export class ApiError extends Error {
    public readonly originalError?: unknown;
    public readonly isNetworkError: boolean;
    public readonly isAbortError: boolean;
    public readonly globalOverloadRetryAtMs?: number;
    public readonly rateLimitedScope?: string;
    public readonly rateLimitedRetryAtMs?: number;
    public readonly rateLimitSuppressed?: boolean;
    public readonly requestId?: string;
    public readonly transparentRateLimitSource?:
        | 'principal'
        | 'global-overload';

    constructor(
        message: string,
        public status?: number,
        public response?: FetchResponse,
        public body?: unknown,
        options: ApiErrorOptions = {},
    ) {
        super(message);
        this.name = 'ApiError';
        this.originalError = options.originalError;
        this.isNetworkError = options.isNetworkError ?? false;
        this.isAbortError = options.isAbortError ?? false;
        this.globalOverloadRetryAtMs = options.globalOverloadRetryAtMs;
        this.rateLimitedScope = options.rateLimitedScope;
        this.rateLimitedRetryAtMs = options.rateLimitedRetryAtMs;
        this.rateLimitSuppressed = options.rateLimitSuppressed;
        this.requestId = options.requestId;
        this.transparentRateLimitSource = options.transparentRateLimitSource;
    }
}
